import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
import Home from '../views/Home.vue';
//import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: Home,
  },

  {
    path: '/recruiter/job-post/:id',
    name: 'candidateReview',
    component: () => import('@/components/CandidateReview/page'),
    meta: { requiresAuth: true, requiresRecruiter: true },
  },
  {
    path: '/contact-us',
    component: () => import('@/views/ContactUs'),
  },
  {
    path: '/terms-and-conditions',
    component: () => import('@/views/Terms'),
  },
  {
    path: '/privacy-policy',
    component: () => import('@/views/Privacy'),
  },
  {
    path: '/ccpa',
    component: () => import('@/views/Ccpa'),
  },
  {
    path: '/reset-password',
    component: () => import('@/views/ResetPassword.vue'),
  },

  {
    path: '/job-board',
    component: () => import('@/views/JobDescriptions.vue'),
    //meta: { requiresAuth: true },
  },

  {
    path: '/recruiter/job-posts',
    component: () => import('@/views/recruiter/RecruiterJobPosts.vue'),
    name: 'JobPosts',
    meta: { requiresAuth: true },
  },

  {
    path: '/404',
    name: '404',
    component: () => import('../views/404'),
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  //const loggedIn = store.getters['loggedIn'];

  if (!to.matched.length) {
    next('/404');
  }

  // if (to.matched.some((record) => record.meta.requiresRecruiter)) {
  //   console.log('REQUIRES RECRUITER!');
  //   console.log(store.getters.getUserType);
  //   // if (isRecruiter !== 'recruiter') {
  //   //   next('/');
  //   // }
  // }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    console.log(localStorage);

    if (localStorage.user) {
      next();
      return;
    }
    console.log('NOT LOGGED IN!!!!!!');
    next('/');

    //next();
  } else {
    console.log('granted');
    // Start the route progress bar.
    NProgress.start();
    next();
  }
});
router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
